import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcCirclePlus = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_17712_30959)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M12.0103 3.00001C16.943 2.99386 21.0077 7.0611 21.0031 11.999C20.9985 17.0086 16.9574 21.0379 11.9093 21C6.98988 20.9626 3.02769 17.005 3.00002 12.0492C2.97235 7.04265 7.01089 3.00616 12.0103 3.00001ZM4.63419 11.9964C4.63522 16.0601 7.92611 19.3653 11.9754 19.3694C16.0519 19.3735 19.3566 16.0775 19.3633 12.001C19.3699 7.95275 16.0611 4.64033 12.0103 4.63982C7.93841 4.63879 4.63317 7.93532 4.63419 11.9964Z",
				fill: "#03A65B"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M11.1837 11.1893C11.1837 11.0848 11.1837 11.0095 11.1837 10.9341C11.1837 9.93079 11.1785 8.92743 11.1862 7.92458C11.1903 7.33886 11.732 6.95351 12.2695 7.14004C12.6082 7.25738 12.8122 7.55768 12.8132 7.9584C12.8158 8.94895 12.8142 9.9395 12.8142 10.93C12.8142 11.0059 12.8142 11.0817 12.8142 11.1899C12.9029 11.1899 12.9762 11.1899 13.05 11.1899C14.0595 11.1899 15.0695 11.1847 16.079 11.1924C16.6652 11.1965 17.0501 11.7382 16.8636 12.2757C16.7457 12.6144 16.4454 12.8184 16.0452 12.8194C15.0546 12.822 14.0641 12.8204 13.0735 12.8204C12.9977 12.8204 12.9219 12.8204 12.8142 12.8204C12.8142 12.9091 12.8142 12.9829 12.8142 13.0562C12.8142 14.0657 12.8194 15.0757 12.8117 16.0852C12.8071 16.6643 12.2808 17.046 11.7468 16.8744C11.3973 16.7621 11.1862 16.4583 11.1852 16.0509C11.1826 15.0603 11.1842 14.0698 11.1842 13.0792C11.1842 13.0034 11.1842 12.9281 11.1842 12.8204C11.095 12.8204 11.0212 12.8204 10.9479 12.8204C9.93842 12.8204 8.9284 12.8256 7.91889 12.8179C7.34035 12.8138 6.95858 12.2875 7.13025 11.7525C7.24247 11.403 7.54532 11.1919 7.95374 11.1909C8.94429 11.1883 9.93484 11.1899 10.9254 11.1899C11.0002 11.1893 11.076 11.1893 11.1837 11.1893Z",
				fill: "#03A65B"
			})]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_17712_30959",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 18.0031,
				height: 18,
				fill: "white",
				transform: "translate(3 3)"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgIcCirclePlus);
export default ForwardRef;
